import { Badge } from '@repo/ui/src/components/ui/badge';

interface PlanBadgeProps {
  planCode: string;
}

/** The org's plan, as one chip. `Plan.name` and `Plan.code` are the same word
 *  in different cases ("Plus" / "PLUS"), so rendering both only said it twice;
 *  the code is the form the rest of the system speaks. Shared between OrgsPage's
 *  table and OrgDetailPage's summary so the two can't drift apart.
 *  Green (`success` = brand tint): the plan is the org's standing, not a
 *  neutral attribute — Johnny's call, 2026-08-29. */
export function PlanBadge({ planCode }: PlanBadgeProps) {
  return <Badge variant="success">{planCode}</Badge>;
}
